import { render, staticRenderFns } from "./DocumentItemComponent.vue?vue&type=template&id=3df77444"
import script from "./DocumentItemComponent.vue?vue&type=script&lang=js"
export * from "./DocumentItemComponent.vue?vue&type=script&lang=js"
import style0 from "./DocumentItemComponent.vue?vue&type=style&index=0&id=3df77444&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports